import { poll } from '../../utils';
import {
  SET_WINDOW_VARIABLES,
  SET_WINDOW_VARIABLE_FETCHING_ERROR
} from './actionTypes';
import { AppActions } from '../../types/store/action';
import { Dispatch } from 'redux';

export const setWindowVariables = (settings: any): AppActions => {
  return {
    type: SET_WINDOW_VARIABLES,
    currency: settings.currency,
    localeId: settings.localeId,
    countryCode: settings.countryCode,
    luna_available: settings.luna_available,
    stadia_available: settings.stadia_available
  };
};

/*Fetch necessary windows variables*/
export const fetchWindowVariables = () => {
  return async function(dispatch: Dispatch) {
    const windowVariablesPromises = await pollWindowVariables([
      'GeoRestrictedResources',
      'anywhereAvailability'
    ]);
    const promiseValues = await Promise.all(windowVariablesPromises);
    try {
      let variables = {
        currency: (promiseValues[0] as any).STOREFRONT_CURRENCY_CODE,
        localeId: (promiseValues[0] as any).STOREFRONT_CURRENT_LOCALE,
        countryCode: (promiseValues[0] as any).GEORESTRICTED_CURRENTSITE,
        luna_available: (promiseValues[1] as any).luna_available,
        stadia_available: (promiseValues[1] as any).stadia_available
      };
      dispatch(setWindowVariables(variables));
    } catch (e) {
      dispatch({ type: SET_WINDOW_VARIABLE_FETCHING_ERROR });
    }
  };
};

export const pollWindowVariables = (properties: string[]) => {
  const promises = properties.map(property => {
    return new Promise(resolve => resolve(pollWindowVariable(property)));
  });

  return promises;
};

export const pollWindowVariable = async (
  property: string,
  timeout: number = 2000
) => {
  try {
    const w = window as any;
    await poll(
      () => {
        return w[property];
      },
      timeout,
      150
    );

    return w[property];
  } catch (error) {
    return null;
  }
};
